export default function ReadOnlyBanner({ reason }: { reason?: string | null }) { if (!reason) return null; return <div role="alert">Your account is read-only ({reason}). <a href="/billing">Update billing</a></div>; }
